<template>
  <div class="text-center align-center teal darken-4">
    <ToolBar />
    <v-btn class="my-2" right x-small fab dark color="warning" fixed>
      <v-icon @click="updateComponent()">mdi-content-save-all</v-icon>
    </v-btn>
    <div ref="componentSection">
      <v-carousel :show-arrows="false" hide-delimiters class="my-6">
        <v-carousel-item>
          <v-sheet
            class="text-center align-center teal darken-4"
            height="100%"
            tile
            contenteditable
          >
            <!--This v-row with align and justify position items in the middle-->
            <v-row class="fill-height" align="center" justify="center">
              <div
                class="h1 text-center align-center teal darken-4"
                style="color:white"
                ref="componentContainer"
              >
                <!--Header goes in here-->
                <div
                  class="mx-4 text-center align-center teal darken-4"
                  :id="'main-div'+index"
                  v-if="content == ''"
                >
                  <v-alert
                    border="left"
                    elevation="24"
                    icon="mdi-school"
                    class="mx-8 text-center align-center teal darken-4"
                    min-width="800"
                  >
                    <h1 class="h1 text-center" style="color:white">Paragraph Component</h1>
                    <div
                      class="h2 font-weight-light"
                      style="color:white"
                    >Maecenas ullamcorper, dui et placerat feugiat, eros pede varius nisi, condimentum viverra felis nunc et lorem. Duis vel nibh at velit scelerisque suscipit. Praesent blandit laoreet nibh. Aenean posuere, tortor sed cursus feugiat, nunc augue blandit nunc, eu sollicitudin urna dolor sagittis lacus. Etiam sollicitudin, ipsum eu pulvinar rutrum, tellus ipsum laoreet sapien, quis venenatis ante odio sit amet eros.</div>
                  </v-alert>
                </div>
                <div v-else v-html="content"></div>
                <!--Header content ends-->
              </div>
            </v-row>
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
    </div>
  </div>
</template>

<script>
import ToolBar from "@/components/myLibrary/Toolbar.vue";
import html2canvas from "html2canvas";

export default {
  props: ["index", "header", "del", "content"],

  components: { ToolBar },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getComponents() {
      return this.$store.getters.getComponents;
    }
  },
  methods: {
    updateComponent() {
      let imgData = null;
      html2canvas(this.$refs.componentSection).then(canvas => {
        imgData = canvas.toDataURL();

        this.$store.commit("updateStoreComponent", {
          index: this.index,
          componentSection: this.$refs.componentContainer.innerHTML,
          imgData: imgData
        });
      });
    }
  }
};
</script>

<style>
</style>